export const MODULE_TYPE = "concept";
export type TYPE = "concept";
